(function () {
  function updateDiscountPrice(productForm) {
    var priceContainer = productForm.querySelector('[data-discount-percentage]');
    var variantSelect = productForm.querySelector('[data-variants]');

    if (!priceContainer || !variantSelect) return;

    var selectedOption = variantSelect.options[variantSelect.selectedIndex];
    var discountPercentage = Number(priceContainer.dataset.discountPercentage);
    var originalPrice = Number(selectedOption && selectedOption.dataset.discountOriginalPrice);

    if (
      !isFinite(discountPercentage)
      || Math.floor(discountPercentage) !== discountPercentage
      || discountPercentage <= 0
      || discountPercentage > 100
      || !isFinite(originalPrice)
      || Math.floor(originalPrice) !== originalPrice
    ) return;

    var price = priceContainer.querySelector('[data-product-price]');
    var comparePrice = priceContainer.querySelector('[data-product-price-compare]');

    if (
      !price
      || !comparePrice
      || !window.Shopify
      || !window.Shopify.formatMoney
      || !window.Theme
      || !window.Theme.moneyFormat
    ) return;

    var discountAmount = Math.floor(originalPrice * discountPercentage / 100);
    var discountedPrice = originalPrice - discountAmount;

    price.innerHTML = Shopify.formatMoney(discountedPrice, window.Theme.moneyFormat);
    price.classList.add('product-price__minimum--sale');
    comparePrice.innerHTML = Shopify.formatMoney(originalPrice, window.Theme.moneyFormat);
    comparePrice.classList.remove('product-price__compare--hidden');
  }

  function updateAllDiscountPrices(root) {
    var productForms = root.querySelectorAll('[data-product-form]');
    for (var i = 0; i < productForms.length; i++) {
      updateDiscountPrice(productForms[i]);
    }
  }

  document.addEventListener('change', function (event) {
    if (!event.target.hasAttribute('data-variants')) return;

    var productForm = event.target.parentNode;
    while (productForm && !productForm.hasAttribute('data-product-form')) {
      productForm = productForm.parentNode;
    }
    if (!productForm) return;

    window.setTimeout(function () {
      updateDiscountPrice(productForm);
    }, 0);
  });

  document.addEventListener('shopify:section:load', function (event) {
    window.setTimeout(function () {
      updateAllDiscountPrices(event.target);
    }, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateAllDiscountPrices(document);
    });
  } else {
    updateAllDiscountPrices(document);
  }
})();
